import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import type { SxProps } from "@mui/material/styles";
import {
  type BillingProduct,
  PRODUCT_DISPLAY_NAMES,
} from "@polifonia/interlude/billingConstants";
import type { BillingFeatureItem } from "@polifonia/interlude/models";
import type { muiTheme } from "@polifonia/theme";
import { theme } from "@polifonia/theme";

import { Typography } from "@/components/Typography";
import { FeaturePricingRow } from "@/pages/billing/v2/tabs/featurePricing/FeaturePricingRow";

const styles = {
  card: {
    border: `1px solid ${theme.colors.neutral020}`,
    borderRadius: "12px",
  },
  cardContent: {
    padding: "24px",
    "&:last-child": {
      paddingBottom: "24px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
  },
} satisfies Record<string, SxProps<typeof muiTheme>>;

interface FeaturePricingCardProps {
  product: BillingProduct;
  features: Array<BillingFeatureItem>;
}

export const FeaturePricingCard: React.FC<FeaturePricingCardProps> =
  function FeaturePricingCard({ product, features }) {
    return (
      <Card variant="outlined" sx={styles.card}>
        <CardContent sx={styles.cardContent}>
          <Box sx={styles.header}>
            <Typography variant="h2">
              {PRODUCT_DISPLAY_NAMES[product]}
            </Typography>
          </Box>
          <Box>
            {features.map((item) => (
              <FeaturePricingRow key={item.feature} item={item} />
            ))}
          </Box>
        </CardContent>
      </Card>
    );
  };
